import { OAUTH_TOKEN_ENDPOINT } from '@/app/core/common/config';

export const createRefreshTokenInterceptor = (store) => {
    const unauthorizedResponseFallback = async (error, axios) => {
        if (error.config?.url === OAUTH_TOKEN_ENDPOINT) {
            return Promise.reject(error);
        }
        if (error.response?.status === 401 && !error.config.headers['X-Retry-After-Refresh']) {
            try {
                await store.dispatch('Auth/renewSession', { showToast: false });
            } catch {
                //
            }
            if (!store.getters['Auth/isLoggedIn']) {
                store.dispatch('Auth/redirectToLogin');
                return Promise.reject(error);
            }

            const newRequestConfig = { ...error.config };
            newRequestConfig.headers['X-Retry-After-Refresh'] = 'true';
            newRequestConfig.headers['Authorization'] =
                axios.defaults.headers.common['Authorization'];
            return axios.request(error.config);
        }

        return Promise.reject(error);
    };

    return {
        successHandler: (response) => response,
        errorHandler: unauthorizedResponseFallback,
    };
};
